
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Image } from "lucide-react";
import VerseImageCreator from './VerseImageCreator';
import { ScriptureResponse } from "@/hooks/useFindScripture";

interface CreateImageButtonProps {
  scripture: ScriptureResponse;
  size?: 'default' | 'sm' | 'lg';
}

const CreateImageButton: React.FC<CreateImageButtonProps> = ({ 
  scripture, 
  size = 'default'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant="outline"
        size={size}
        onClick={handleOpenModal}
        className="flex items-center gap-1"
      >
        <Image className="h-4 w-4" />
        <span>Create Image</span>
      </Button>

      <VerseImageCreator
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        verseText={scripture.text}
        verseReference={scripture.reference}
      />
    </>
  );
};

export default CreateImageButton;
